import React from 'react';

import { InfiniteTable } from '../../components';

import { ListingRow } from '../atoms';

const headers = [
  'Brand', 'Model', 'Reference Number', 'Listing Price', 'Status', 'Date',
];

export function MerchantListings({ merchant }) {
  return (
    <div className="p-3 mb-4 mt-4 list-container">
      <InfiniteTable
        className="contacts mobile-alternative sub-list"
        fetchUrl={`/api/listings/search`}
        responsive={false}
        fetchParams={{
          list: 'network',
          query: '',
          filters: {
            owner_id: merchant.id,
          },
        }}
        fetchLimit={25}
        emptyText="No listings found for this merchant."
        headers={headers}
        onSelectClick={() => {}}
        RowComponent={ListingRow}
      />
    </div>
  );
}

